export const ASSETS = {
  CRUNCHER_LOGO: '/logo/cruncher-logo.svg',
  CRUNCHER_LOGO_WHITE: '/logo/cruncher-logo-white.svg',
  CRUNCHER_LOGO_COMPACT: '/logo/cruncher-logo-compact.svg',
};
